import styled from "styled-components";
import React from "react";
import { Modal } from "semantic-ui-react";
import { ILIcon, UserAvatar as UserIcon } from "./Icons";
import { closeIcon } from "components/Icons";
import IconContainer from "./IconContainer";
import colors from "styles/colors";
import typography from "styles/typography";
import Text from "new_components/atoms/Text";

const Question = (props) => {
  const { content, hasFlag, score } = props;

  return (
    <QuestionContainer>
      <QuestionBox>
        {content}
        {score !== undefined && <ScoreDisplay>User scored this {score}</ScoreDisplay>}
      </QuestionBox>
      {hasFlag && <FlagIndicator>!</FlagIndicator>}
      <UserAvatar>
        <IconContainer icon={UserIcon()} />
      </UserAvatar>
    </QuestionContainer>
  );
};

const Response = (props) => {
  const { content } = props;

  return (
    <ResponseContainer>
      <AIAvatar>
        <IconContainer backgroundColor="#2D70E2" icon={ILIcon("#FFF")} />
      </AIAvatar>
      <ResponseBox>
        <Text
          typographyStyle={typography.smallText.semibold}
          color={colors.primary[500]}
          style={{ marginBottom: 6 }}
        >
          Innerlogic AI Follow up
        </Text>
        {content}</ResponseBox>
    </ResponseContainer>
  );
};

const ChatModal = ({ open, setOpen, selectedConversation }) => {
  if (!selectedConversation) return null;

  // Check if this is a comment (no score) vs feedback (has score)
  const isComment = selectedConversation.type === "Comment" || !selectedConversation.score;

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      size="small"
    >
      <Content>
        <TopSection>
         
          <CloseButton onClick={() => setOpen(false)}>
            {closeIcon("#2A3039")}
          </CloseButton>
        </TopSection>

        <MainQuestionSection>
          <QuestionTitle>{selectedConversation.question}</QuestionTitle>
          {!isComment && (
            <ScoreSection>
              Respondent scored a <ScoreLabel>{selectedConversation.score}/10</ScoreLabel>
            </ScoreSection>
          )}
          <FeedbackSection isComment={isComment}>
            {!isComment && <FeedbackLabel>Respondent's feedback:</FeedbackLabel>}
            <FeedbackText>{selectedConversation.feedback}</FeedbackText>
          </FeedbackSection>
        </MainQuestionSection>

        <ConversationContainer>
          <Thread>
            {selectedConversation.hasFollowUp && selectedConversation?.follow_up_question?.length > 0 && (
              <>
                <Response content={selectedConversation.follow_up_question} />
                <Question content={selectedConversation.follow_up_response} />
              </>
            )}
          </Thread>
        </ConversationContainer>
      </Content>
    </Modal>
  );
};

export default ChatModal;

const Content = styled.div`
  padding: 20px;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
    margin-top: 10px;
    margin-bottom: 35px;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: rgba(0, 0, 0, 0);
    position: absolute;
    left: 0;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.03);
    padding-left: 16px;
  }
`;

const T2 = styled.div`
  font-family: Raleway;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 128%;
  color: #2a3039;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const Thread = styled.div``;

const ConversationContainer = styled.div`
  margin-top: 20px;
`;

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  margin-right: 0;
  margin-left: auto;
  max-width: 550px;
`;

const QuestionBox = styled.div`
  padding: 16px;
  border-radius: 8px;
  background: #f8faff;
  line-height: 18px;
  margin-right: 0;
  margin-left: auto;
`;

const ScoreDisplay = styled.div`
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
  font-size: 13px;
  font-style: italic;
  color: #666d79;
  font-weight: 500;
`;

const UserAvatar = styled.div`
  margin-left: 8px;
`;

const ResponseContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  max-width: 400px;
`;

const AIAvatar = styled.div`
  margin-right: 8px;
`;

const ResponseBox = styled.div`
  padding: 16px;
  border-radius: 8px;
  background: #f8faff;
  line-height: 18px;
  display: flex;
  flex-direction: column;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const FlagIndicator = styled.div`
  display: flex;
  align-items: center;
  position: absolte;
  justify-content: center;
  background: #f15062;
  border-radius: 10px;
  color: #fff;
  padding: 10px;
  width: 15px;
  height: 15px;
  font-size: 12px;
  right: -35px;
  bottom: 6px;
  z-index: 99;
  margin-right: -20px;
  position: relative;
`;

const MainQuestionSection = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 8px;
`;

const QuestionTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 12px;
  color: #2a3039;
`;

const ScoreSection = styled.div`
  font-size: 14px;
  color: #666d79;
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
`;

const ScoreLabel = styled.div`
  font-weight: 600;
  margin-left: 4px;
  color: ${colors.primary[500]};
`;

const FeedbackSection = styled.div`
  margin-top: ${({ isComment }) => isComment ? '0' : '12px'};
  padding-top: ${({ isComment }) => isComment ? '0' : '12px'};
  border-top: ${({ isComment }) => isComment ? 'none' : '1px solid #e5e7eb'};
`;

const FeedbackLabel = styled.div`
  font-weight: 600;
  margin-bottom: 8px;
  color: #2a3039;
`;

const FeedbackText = styled.div`
  font-size: 16px;
  line-height: 1.8;
  color: #666d79;
`;
